import React, { useState, useCallback, useEffect } from 'react'
import { Input } from './ProgressBar.styles'

const calculateBackgroundSize = (value, min, max) => {
  return `${((value - min) * 100) / (max - min)}% 100%`
}

export default function ProgressBar({
  value,
  min,
  max,
  onMouseDown,
  onChange,
  onMouseUp,
  onTouchEnd,
  disabled,
  inputStyle = {}
}) {
  const [backgroundSize, setBackgroundSize] = useState(
    calculateBackgroundSize(value, min, max)
  )

  useEffect(() => {
    setBackgroundSize(calculateBackgroundSize(value, min, max))
  }, [value, min, max])

  const handleInputChange = useCallback(
    (e) => {
      const { min: minValue, max: maxValue, value: val } = e.target
      const numericValue = Number(val)

      setBackgroundSize(
        calculateBackgroundSize(
          numericValue,
          Number(minValue),
          Number(maxValue)
        )
      )

      if (onChange) {
        onChange(e)
      }
    },
    [onChange]
  )

  return (
    <>
      <Input
        type="range"
        value={String(value)}
        min={String(min)}
        max={String(max)}
        step="any"
        onChange={handleInputChange}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onTouchEnd={onTouchEnd}
        style={{ ...inputStyle, backgroundSize }}
        disabled={disabled}
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        aria-label="Volume Slider"
      />
    </>
  )
}
